/*
 ---
 Class Timeentry.
 (Scenes)
 ---
 */
angular.module('app.classes.timeentry', []).//
service('TimeEntry', ['xCenterConfig',
    function (xCenterConfig) {

        var b = function() {
            var o = {};

            var getSeekedDay = (weekDay) => {
                /* See: https://stackoverflow.com/a/39614998 */

                const today = moment().isoWeekday();
                const isoWeekdayINeed = weekDay;
                let dayINeed;

                // if we haven't yet passed the day of the week that I need
                if (today <= isoWeekdayINeed) {
                    // then just give me this week's instance of that day
                    dayINeed = moment().isoWeekday(isoWeekdayINeed);
                } else {
                    // otherwise, give me *next week's* instance of that same day
                    dayINeed = moment().add(1, 'weeks').isoWeekday(isoWeekdayINeed);
                }

                return dayINeed;
            }

            o.left = 0;
            o.width = 10;
            // Point one is always the left one
            o.pointOneSec = {};
            o.pointOneX = 0;
            // Point one is always the right one
            o.pointTwoSec = {};
            o.pointTwoX = 0;
            //o.endpx : nl,
            //initLeft' :nl,
            o.moving = false;
            //'end' : undefined,
            o.element = {};
            o.$document = {};
            // -------------------------------------------//
            //            Init the entry
            // -------------------------------------------//
            o.initEntry = function (scope, e, entry) {
                //$document = angular.element('document');
                o.scope = scope;
                o.element = e;
                o.entry = entry;
                o.quarterPx = o.SecToPx((60 * 15));

                entry.Start = entry.Start || getSeekedDay(scope.weekday).set({ seconds: 0, milliseconds: 0 });
                entry.End = entry.End || getSeekedDay(scope.weekday).set({ seconds: 0, milliseconds: 0 });

                o.setPositionByTime( entry.Start, entry.End );
                // Set internal UTC Property (Working and everytime final DateString
                o.StartUTC = entry.Start;
                o.EndUTC = entry.End;
                o.AstroOffsetEnd = entry.AstroOffsetEnd ? entry.AstroOffsetEnd : undefined;
                o.AstroOffsetStart = entry.AstroOffsetStart ? entry.AstroOffsetStart : undefined;
                o.AstroTypeEnd = entry.AstroTypeEnd ? entry.AstroTypeEnd : undefined;
                o.AstroTypeStart = entry.AstroTypeStart ? entry.AstroTypeStart : undefined;
                o.ReferenceDay = entry.ReferenceDay ? entry.ReferenceDay : undefined;
                o.AstroIconStart = entry.AstroIconStart ? entry.AstroIconStart : undefined;
                o.AstroIconEnd = entry.AstroIconEnd ? entry.AstroIconEnd : undefined;

                /* The condition is there because upon drag start, the current time would be shown. */
                if (o.width !== 0) {
                    var eEnd,s;
                    eEnd = moment(entry.End);
                    if(entry.End.isSame(moment(entry.Start).set({ 'hour': 24, 'minute': 0, 'second': 0, 'milliseconds': 0 })))
                    {
                        s = '';
                        eEnd = '24:00';
                    }else{
                        s = eEnd.format('ss') > 0 ? ':'+eEnd.format('ss') : '';
                        eEnd = eEnd.format('HH:mm');
                    }
                    o.displayValue = moment(entry.Start).format('HH:mm')+ ' - ' + eEnd;
                }

                //o.displayValue =
                console.log(moment(entry.Start).format(xCenterConfig.timeprogram.defaultEntryTimeFormat + '.SSS') + ' - ' + moment(entry.End).format(xCenterConfig.timeprogram.defaultEntryTimeFormat + '.SSS'));

                o.wholeEntry = o.element.find('div').eq(1);
                o.leftHandle = o.element.find('span').eq(0);
                o.rightHandle = o.element.find('span').eq(1);
            };
            // -------------------------------------------//
            //            Init by timeline
            // -------------------------------------------//
            o.setPositionByTime = function (start, end) {

                let dStart = start;
                let dEnd = end;

                var startSec = parseInt(dStart.format('s')) + ( 60 * parseInt(dStart.format('m')) ) + ( 60 * 60 * parseInt(dStart.format('H')) );
                var endSec;
                // Its midnight.
                if (dEnd.isSame(moment(dStart).set({ 'hour': 24, 'minute': 0, 'second': 0, milliseconds: 0 })) ) {
                    endSec =  60 * 60 * 24 ;

                } else {
                    endSec = parseInt(dEnd.format('s')) + ( 60 * parseInt(dEnd.format('m')) ) + ( 60 * 60 * parseInt(dEnd.format('H')) );
                }


                var durationSec = endSec - startSec;


                o.pointOneX = o.SecToPx(startSec);
                o.pointTwoX = o.SecToPx(endSec);
                o.offsetToPointOne = o.SecToPx(startSec);
                o.offsetToPointTwo = o.SecToPx(endSec);
                o.left = o.SecToPx(startSec);
                o.width = o.SecToPx(durationSec);

                //o.start = o.pxToSec(o.left);
                //o.end = o.pxToSec(o.left + o.width);

                return this;
            };

            // -------------------------------------------//
            //              setPoint One by PX
            // -------------------------------------------//
            o.setpointOneX = function (px) {
                o.pointOneX = px;
                o.left = px;
                o.start = o.pxToSec(o.left);
                return this;
            };

            o.setpointTwoX = function (px) {
                o.pointTwoX = px;
                o.width = px - o.left;
                o.end = o.pxToSec(px);
                return this;
            };

            o.mouseStartDragEntry = function (e, event) {
                event.preventDefault();
                event.stopPropagation();
                event.touches = [{clientX: event.clientX, clientY: event.clientY}];
                o.startDragEntry(e, event);
            };

            // -------------------------------------------//
            //              StartDrag whole Entry
            // -------------------------------------------//
            o.startDragEntry = function (e, event) {

                if(!o.scope.editMode){ return; };
                var pageX = event.touches[0].clientX;
                if (

                    o.scope.condition.$UI.copyDays == undefined
                    || (o.scope.condition.$UI.copyDays && o.scope.condition.$UI.copyDays[o.scope.weekdaystring] )

                ) {
                    // Start dragging whole Entry
                    var aktleft = pageX - o.scope.offset();
                    aktleft = ( Math.floor(aktleft / o.quarterPx) * o.quarterPx );
                    // Set initial left, so we
                    o.scope.moveEl = e;
                    o.moving = true;
                    o.offsetToPointOne = aktleft - o.pointOneX;
                    o.offsetToPointTwo = o.pointTwoX - aktleft;
                    o.startDragPx = aktleft;


                    o.$document.off('touchmove', o.drag);
                    o.$document.off('mousemove', o.touchDrag);
                    o.$document.off('mouseup touchend', o.stopDrag);

                    o.$document.on('touchmove', o.dragEntry);
                    o.$document.on('mousemove', o.touchDragEntry);
                    o.$document.on('mouseup touchend', o.stopDragEntry);
                }
            };

            o.touchDragEntry = function (e) {
                if(!o.scope.editMode){ return; };
                e.touches = [{clientX: e.clientX, clientY: e.clientY}];
                o.dragEntry(e);
            };

            // -------------------------------------------//
            //              Drag Entry  (Whole entry)
            // -------------------------------------------//
            o.dragEntry = function (event) {
                if(!o.scope.editMode){ return; };
                //var aktleft = (event.pageX -  o.offset(o.element)﻿.left);
                //var aktleft = event.pageX -  o.scope.offset();
                var pageX = event.touches[0].clientX;

                var aktleft = (pageX - o.offset(o.element).left);
                //aktleft = ( Math.floor( ( aktleft / o.scope.timelineStep ) ) ) * o.scope.timelineStep;
                aktleft = ( Math.floor(aktleft / o.quarterPx) * o.quarterPx );

                var pointOne = ( aktleft - o.offsetToPointOne );
                var pointTwo = ( aktleft + o.offsetToPointTwo );
                if (pointTwo >= 720) {
                    pointTwo = 720;
                    pointOne = 720 - (o.offsetToPointOne + o.offsetToPointTwo);
                }
                if (pointOne < 0) {
                    pointTwo = (o.offsetToPointOne + o.offsetToPointTwo);
                    pointOne = 0;
                }

                o.scope.moveEl.pointOneX = pointOne;
                o.scope.moveEl.pointTwoX = pointTwo;

                o.scope.moveEl.left = o.scope.moveEl.pointOneX;
                o.scope.moveEl.width = pointTwo - pointOne;
                o.scope.moveEl.end = o.pxToSec(o.scope.moveEl.pointTwoX);
                o.scope.moveEl.start = o.pxToSec(o.scope.moveEl.pointOneX);
                o.setStartEndByTime(o.scope.moveEl,o.scope.moveEl.start,o.scope.moveEl.end);

                o.applyTimelines(o.scope);


            };

            // -------------------------------------------//
            //              Stop drag whole Entry
            // -------------------------------------------//
            o.stopDragEntry = function (event) {
                o.scope.cleanUpEntrys({
                    fn: function () {
                        o.byHandle = false;
                        o.moving = false;

                        o.scope.pushToTimeProgram();
                        // Apply to the other;
                        o.setStartEndByTime(o.scope.moveEl,o.scope.moveEl.start,o.scope.moveEl.end);
                        o.scope.moveEl = undefined;
                        o.applyTimelines(o.scope);


                        o.$document.off('touchmove',o.dragEntry);
                        o.$document.off('mousemove', o.touchDragEntry);
                        o.$document.off('mouseup touchend', o.stopDragEntry);
                    }
                });
            };


            o.mouseStartDrag = function (event, e, byHandle) {
                if(!o.scope.editMode){ return; };
                event.touches = [{clientX: event.clientX, clientY: event.clientY}];
                o.startDrag(event, e, byHandle);
            };
            // -------------------------------------------//
            //          Start Draging
            // -------------------------------------------//
            o.startDrag = function (event, e, byHandle) {
                if(!o.scope.editMode){ return; };
                event.preventDefault();
                event.stopPropagation();
                if (o.scope.condition.$UI == undefined) {
                    o.scope.condition.$UI = {};
                }

                if (o.scope.condition.$UI.copyDays == undefined
                    || (o.scope.condition.$UI.copyDays && o.scope.condition.$UI.copyDays[o.scope.weekdaystring])
                ) {
                    var pageX = event.touches[0].clientX;
                    var aktleft = pageX - o.scope.offset();
                    aktleft = ( Math.floor(( aktleft / o.scope.timelineStep )) ) * o.scope.timelineStep;

                    if (byHandle == true) {
                        if (e.left < (aktleft - o.scope.minTimeEntryMin)) {
                            e.dragpoint = 'two';
                        } else {
                            e.dragpoint = 'one';
                        }
                    }
                    if (e.pointOneX == e.pointTwoX) {
                        // on first Init;
                        e.end = o.pxToSec(e.pointTwoX);
                        e.start = o.pxToSec(e.pointOneX);
                    }
                    o.scope.moveEl = e;

                    o.$document.off('touchmove', o.dragEntry);
                    o.$document.off('mousemove', o.touchDragEntry);
                    o.$document.off('mouseup touchend', o.stopDragEntry);

                    o.$document.on('touchmove', o.drag);
                    o.$document.on('mousemove', o.touchDrag);
                    o.$document.on('mouseup touchend', o.stopDrag);
                    o.moving = true;

                    if (o.end == undefined) {
                    } else {
                        // Check if we
                    }
                }
                ;

            };

            o.touchDrag = function (e) {
                if(!o.scope.editMode){ return; };
                e.touches = [{clientX: e.clientX, clientY: e.clientY}];
                o.drag(e);
            };

            // -------------------------------------------//
            //              Drag this
            // -------------------------------------------//
            o.drag = function (event) {
                event.stopPropagation();
                event.preventDefault();
                // switch left and right moving!
                var left, nw;
                var pageX = event.touches[0].clientX;
                var aktleft = (pageX - o.offset(o.element).left);
                aktleft = ( Math.floor(aktleft / o.quarterPx) * o.quarterPx );
                if (aktleft < 0) {
                    aktleft = 0;
                } else if (aktleft >= o.scope.timelinewidth) {
                    aktleft = o.scope.timelinewidth;
                }
                if (!o.scope.moveEl) {
                    return
                };
                if (o.scope.moveEl && o.scope.moveEl.dragpoint == undefined) {
                    if (o.scope.moveEl.initLeft > aktleft) {
                        // We are moving initially to the left
                        //
                        o.scope.moveEl.dragpoint = 'one';
                    } else {
                        o.scope.moveEl.dragpoint = 'two';
                    }
                    left = aktleft;
                }

                if (o.scope.moveEl && o.scope.moveEl.dragpoint && o.scope.moveEl.dragpoint == 'one') {
                    // Dragging left point
                    if (aktleft < o.scope.moveEl.pointTwoX) {
                        // Ok move left point
                        o.scope.moveEl.pointOneX = aktleft;
                        left = aktleft;
                        nw = o.scope.moveEl.pointTwoX - aktleft;
                    } else {
                        // switch points and move the right point
                        o.scope.moveEl.dragpoint = "two";
                        o.scope.moveEl.pointOneX = o.scope.moveEl.pointTwoX;
                        o.scope.moveEl.pointTwoX = aktleft;
                        left = o.scope.moveEl.pointTwoX;
                        //o.scope.moveEl.pointTwoX = aktleft;

                        nw = aktleft - left;
                    }
                } else if (o.scope.moveEl && o.scope.moveEl.dragpoint && o.scope.moveEl.dragpoint == 'two') {
                    // dragging right point
                    if (aktleft > o.scope.moveEl.pointOneX) {
                        // Ok move left point
                        o.scope.moveEl.pointTwoX = aktleft;
                        left = o.scope.moveEl.pointOneX;
                        nw = aktleft - o.scope.moveEl.pointOneX;

                    } else {
                        // switch points and move the right point
                        o.scope.moveEl.dragpoint = "one";
                        o.scope.moveEl.pointTwoX = o.scope.moveEl.pointOneX;
                        o.scope.moveEl.pointOneX = aktleft;
                        //o.scope.moveEl.pointTwoX = aktleft;
                        left = aktleft;
                        nw = o.scope.moveEl.pointTwoX - aktleft;
                    }

                }


                o.scope.moveEl.left = left;


                o.scope.moveEl.width = nw;
                if (!o.scope.moveEl.background) {
                    o.scope.moveEl.background = 'background-color:rgba(168,203,48,1)';
                }

                o.scope.moveEl.end = o.pxToSec(o.scope.moveEl.pointTwoX);
                o.scope.moveEl.start = o.pxToSec(o.scope.moveEl.pointOneX);
                o.setStartEndByTime(o.scope.moveEl,o.scope.moveEl.start,o.scope.moveEl.end);
                o.applyTimelines(o.scope);

                //o.scope.$apply();
            };

            // -------------------------------------------//
            //              Stop DRag
            // -------------------------------------------//
            o.stopDrag = function (event) {
                var t = this;

                o.scope.cleanUpEntrys({
                    fn: function () {
                        o.byHandle = false;
                        o.moving = false;


                        //
                        // Update The WeekProgram Entry
                        // Start and End. On this Date apiOject will rely
                        //


                        o.setStartEndByTime(o.scope.moveEl,o.scope.moveEl.start,o.scope.moveEl.end);

                        o.scope.pushToTimeProgram();

                        //
                        //o.scope.scene.days[o.scope.day].entrys = o.scope.scene.days[o.scope.day].entrys;
                        // Apply to the other;
                        //


                        o.applyTimelines(o.scope);
                        o.scope.moveEl = undefined;
                        o.$document.off('touchmove', t.drag);
                        o.$document.off('mousemove', t.touchDrag);
                        o.$document.off('mouseup touchend', t.stopDrag);
                        //t.scope.$apply();
                    }
                });

            }

            o.setStartEndByTime = function(entry,start,end){
                var eEnd, eStart;
                if (end.hours === 24) {
                    eEnd = moment(entry.End).set({
                        hours: 24,
                        minutes: 0,
                        seconds: 0,
                        milliseconds: 0
                    });
                } else {
                    eEnd = moment(entry.End).set({
                        hours: end.hours,
                        minutes: end.mins,
                        seconds: 0,
                        milliseconds: 0
                    });
                }

                eStart = moment(entry.Start).set({
                    hours: start.hours,
                    minutes: start.mins,
                    seconds: 0,
                    milliseconds: 0
                });

                /* Needed for a manual weektime program with an end at 24:00. */
                entry.ReferenceDay = eStart.clone();

                // Set Display Date

                entry.StartUTC = eStart;
                entry.EndUTC = eEnd;
                entry.displayValue
                    = (start.hours === 24 ? '24:00' : eStart.format('HH:mm'))
                    + ' - '
                    + (end.hours === 24 ? '24:00' : eEnd.format('HH:mm'));

            }

            // -------------------------------------------//
            //              Calculate offset
            // -------------------------------------------//
            o.offset = function (elm) {
                try {
                    return elm.o.offset();
                } catch (e) {
                }
                var rawDom = elm[0];
                var _x = 0;
                var _y = 0;
                var body = document.documentElement || document.body;
                var scrollX = window.pageXOffset || body.scrollLeft;
                var scrollY = window.pageYOffset || body.scrollTop;
                _x = rawDom.getBoundingClientRect().left + scrollX;
                _y = rawDom.getBoundingClientRect().top + scrollY;
                return {left: _x, top: _y};
            };


            // -------------------------------------------//
            //              Apply other timelines
            // -------------------------------------------//
            o.applyTimelines = function (scope) {
                if (scope.condition != undefined && scope.condition.$UI.copyMode == true) {
                   var c = scope.condition;
                    c.$UI.copyMaster = scope.day;
                    // Push Entrys from Master Timeline
                    var masterEntrys = scope.entries;
                    //console.log('MASTERENTRYS',masterEntrys);
                    //var keys = Object.keys(c.copyDays);

                    for (var key in c.$UI.copyDays) {

                        if (c.$UI.copyDays.hasOwnProperty(key) && c.$UI.copyDays[key] && c.$UI.copyDays[key].WeekDay != c.$UI.copyMaster.WeekDay) {
                            // Getting mo, tue, wed...
                            var thisDay = scope.condition.$UI.copyDays[key];
                            // Todo: remove walkDown with lodash function
                            scope.condition.ConditionData.TimeProgram.WeekProgramEntries.walkDown(
                                function (o, i) {
                                    if (o.WeekDay == thisDay.WeekDay) {
                                        scope.condition.ConditionData.TimeProgram.WeekProgramEntries.splice(i, 1);
                                    }
                                })

                            if (thisDay.WeekDay != c.$UI.copyMaster.WeekDay) {

                                scope.rootScope.$broadcast('timeline_refresh' + thisDay.WeekDay, {entries: masterEntrys});
                            }


                        }

                    }


                }
                //scope.$digest();
                scope.$apply();

            };


            // -------------------------------------------//
            //              Sec to PX
            // -------------------------------------------//
            o.SecToPx = function (sec) {
                // 100% px is timelinewidth
                var p = (sec  ) / ( 24 * 3600 );


                return p * o.scope.timelinewidth;
            };

            // -------------------------------------------//
            //              PX to Sec
            // -------------------------------------------//
            o.pxToSec = function (px) {
                // 100% px is timelinewidth
                var p = px / o.scope.timelinewidth;
                var secFromZero = p * ( 3600 * 24 );
                var a = {};

                a.onlySec = secFromZero;
                a.hours = Math.floor(secFromZero / 3600);
                a.mins = ( (secFromZero - ( a.hours * 3600 ) ) / 60 );
                //console.log(a.mins);
                if (a.mins.toString() != '00') {
                    a.mins = ( (secFromZero - ( a.hours * 3600 ) ) / 60  );
                }
                if (a.hours == 24 && a.mins.toString() == '00') {
                    a.hours = 23;
                    a.mins = 59;
                }
                //a.sec = o.padZero( Math.floor(secFromZero - (a.hours * 3600) - (a.mins * 60 ) ) );
                return a;
            };

            /*    o.padZero = function (s) {
                return (s == 0) ? '00' : ( (s.toString().length < 2) ? "0" + Math.floor(s) : Math.floor(s) );
            };*/
            o.padZero = function pad(n) {
                var width = 2;
                z =  '0';
                n = n + '';
                return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
            }

            // -------------------------------------------//
            //              Generate object for API Call
            // -------------------------------------------//

            o.apiObject = function () {


                /*
                var sTime = o.padZero(o.start.hours) + ':' + o.padZero(Math.round(o.start.mins)) + ':00';
                var eTime = o.padZero(o.end.hours) + ':' + o.padZero(Math.round(o.end.mins)) + ':00';

                if (o.end.hours >= 23 && o.end.mins > 59) {
                    eTime = '24:00';
                }
                */

                // apiObject rely on o.entry.Start
                // o.entry.Start will be updated at drop

                //o.End = '0001-01-01T' + eTime;
                //o.Start = '0001-01-01T' + sTime;

                var oo = {
                    "Enabled": true,
                    "Start": o.StartUTC,
                    "End": o.EndUTC,
                    "WeekDay": o.scope.weekday,
                    AstroOffsetEnd: o.AstroOffsetEnd,
                    AstroOffsetStart: o.AstroOffsetStart,
                    AstroTypeEnd: o.AstroTypeEnd,
                    AstroTypeStart: o.AstroTypeStart,
                    ReferenceDay: o.ReferenceDay,
                    AstroIconStart: o.AstroIconStart,
                    AstroIconEnd: o.AstroIconEnd
                };
                return oo;
            };




            return o;
        }


        return function(){
            return new b();
        }

    }]);
